import configure, {type SettingsOptions, type SettingsPreferences} from "@pata/settings";
import * as settings from "@pata/settings";
import navConfig from "./navigation";
import presetConfig from './presets'

configure({
    navigation: navConfig,
    name: "PATA",
    domain: process.env.NEXT_PUBLIC_DOMAIN_NAME ?? "",
    email: process.env.NEXT_PUBLIC_CONTACT_EMAIL ?? "",
    presets: presetConfig,
    localization: {
        locales: ['lv', 'en', 'cn', 'lt'],
        default: 'lv'
    },
    tracking: {
        fbId: '378537766706161',
        gtmId: 'GTM-P8V39JG',
    }
})

export const preferences: Readonly<SettingsPreferences> = settings.preferences()
export const options: Readonly<SettingsOptions> = settings.options()